// Wrapper to communicate with the Web Worker cleanly
import { Product } from '../types';

export interface CSVRowPreview {
  index: number;
  id?: string;
  name: string;
  category: string;
  mrp: number;
  price: number;
  available: boolean;
  showQuantity: boolean;
  quantityValue?: number;
  quantityUnit: string;
  description: string;
  imageUrl: string;
  order: number;
  action: 'insert' | 'update' | 'error';
  errorDetails?: string;
  existingProduct?: Product;
  imageStatus?: 'existing' | 'new' | 'none';
}

export interface TranslationResult {
  original: string;
  translated: string;
  changed: boolean;
}

export function parseCSVAsync(
  text: string,
  products: Product[],
  categories: readonly string[]
): Promise<CSVRowPreview[]> {
  return new Promise((resolve, reject) => {
    try {
      const worker = new Worker(
        new URL('./dataProcessor.worker.ts', import.meta.url),
        { type: 'module' }
      );
      
      worker.onmessage = (e) => {
        const { type, payload } = e.data;
        if (type === 'PARSE_CSV_SUCCESS') {
          resolve(payload);
          worker.terminate();
        } else if (type === 'ERROR') {
          reject(new Error(payload));
          worker.terminate();
        }
      };

      worker.onerror = (err) => {
        reject(err);
        worker.terminate();
      };

      worker.postMessage({
        type: 'PARSE_CSV',
        payload: { text, products, categories }
      });
    } catch (error) {
      reject(error);
    }
  });
}

export function translateVoiceAsync(text: string): Promise<TranslationResult> {
  return new Promise((resolve, reject) => {
    try {
      const worker = new Worker(
        new URL('./dataProcessor.worker.ts', import.meta.url),
        { type: 'module' }
      );

      worker.onmessage = (e) => {
        const { type, payload } = e.data;
        if (type === 'TRANSLATE_VOICE_SUCCESS') {
          resolve(payload);
          worker.terminate();
        } else if (type === 'ERROR') {
          reject(new Error(payload));
          worker.terminate();
        }
      };

      worker.onerror = (err) => {
        reject(err);
        worker.terminate();
      };

      worker.postMessage({
        type: 'TRANSLATE_VOICE',
        payload: { text }
      });
    } catch (error) {
      reject(error);
    }
  });
}
